import styled, { useTheme } from 'styled-components';
import { NotificationHistory } from '../../../2_domain/notification/notification';
import { LXh5 } from '../../core/texts/lxText';

const LXDivider = styled.div`
  height: 1px;
  background-color: ${(props) => props.theme.colors.grayLine};
`;

interface DividerProps {
  base: Date | undefined;
  today: Date;
  item: NotificationHistory;
}

const DayOfWeek = [
  'Monday',
  'TuesDay',
  'Wednesday',
  'ThursDay',
  'Friday',
  'Saturday',
  'Sunday',
];

const Divider = ({ base, today, item }: DividerProps) => {
  const theme = useTheme();
  const b = base
    ? {
        year: base.getFullYear(),
        month: base.getMonth() + 1,
        day: base.getDate(),
      }
    : null;
  const t = {
    year: today.getFullYear(),
    month: today.getMonth() + 1,
    day: today.getDate(),
  };
  const i = {
    year: item.createdAt.getFullYear(),
    month: item.createdAt.getMonth() + 1,
    day: item.createdAt.getDate(),
    date: item.createdAt.getDay(),
  };

  if (i.year === b?.year && i.month === b.month && i.day === b.day)
    return <LXDivider></LXDivider>;
  // today
  else if (i.year === t.year && i.month === t.month && i.day === t.day)
    return <LXh5 color={theme.colors.caption}>{theme.texts.today}</LXh5>;
  // yesterday
  else if (i.year === t.year && i.month === t.month && t.day - i.day === 1)
    return (
      <LXh5 height="38px" lineHeight="58px" color={theme.colors.caption}>
        {theme.texts.yesterday}
      </LXh5>
    );
  else
    return (
      <LXh5 height="48px" lineHeight="78px" color={theme.colors.caption}>{`${
        DayOfWeek[i.date]
      } ${i.day}-${i.month}-${i.year}`}</LXh5>
    );
};

export default Divider;
